import { render, staticRenderFns } from "./SectionProductsGrid.vue?vue&type=template&id=184bb950&scoped=true&"
import script from "./SectionProductsGrid.vue?vue&type=script&lang=js&"
export * from "./SectionProductsGrid.vue?vue&type=script&lang=js&"
import style0 from "./SectionProductsGrid.vue?vue&type=style&index=0&id=184bb950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184bb950",
  null
  
)

export default component.exports